import { render, staticRenderFns } from "./TrainingOnline.vue?vue&type=template&id=4350b02c&scoped=true"
import script from "./TrainingOnline.vue?vue&type=script&lang=js"
export * from "./TrainingOnline.vue?vue&type=script&lang=js"
import style0 from "./TrainingOnline.vue?vue&type=style&index=0&id=4350b02c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350b02c",
  null
  
)

export default component.exports